import { i18n } from "@/i18n";
import { SIDENAV_GROUP_BY } from "@/constants";
import { buildOrgUrl } from "@/utils/navigation/orgUrl";

export const MSP_NAV_ITEMS = [
  {
    order: 0,
    groupBy: SIDENAV_GROUP_BY.ALPHA,
    label: i18n.global.t("sidebar-dashboard"),
    icon: "cl-icon-columns-gap",
    id: buildOrgUrl("msp", null, "dashboard"),
    exact: false,
    dataTestId: "msp-dashboard-page",
  },
];

export const CUSTOMER_NAV_ITEMS = [
  {
    order: 0,
    groupBy: SIDENAV_GROUP_BY.ALPHA,
    label: i18n.global.t("sidebar-dashboard"),
    icon: "cl-icon-columns-gap",
    id: buildOrgUrl("customer", null, "dashboard"),
    exact: false,
    dataTestId: "customer-dashboard-page",
  },
];

export default {};
